import ic_search_white from 'url:/assets/ic_search_white.svg'
import ic_add_btn_small from 'url:/assets/ic_add_btn_small.svg'
import DeleteSvg from 'jsx:/assets/delete.svg'
import edit from 'url:/assets/edit.svg'
import settings from 'url:/assets/settings.svg'
import React, { ButtonHTMLAttributes } from 'react'
import classNames from 'classnames'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { color?: ButtonColors }
interface ButtonClasses {
  primary: string
  secondary: string
  action: string
  danger: string
}
const buttonClasses: ButtonClasses = {
  primary: 'text-primaryButtonFontColor bg-primaryButtonColor hover:bg-primaryButtonHoverColor',
  secondary:
    'text-primaryFontColor bg-neutralButtonColor border border-primaryButtonColor hover:bg-neutralButtonHoverColor',
  action: 'text-primaryButtonColor',
  danger: 'text-primaryButtonFontColor bg-alertButtonColor hover:bg-alertButtonHoverColor',
}
type ButtonColors = keyof ButtonClasses

export const FORM_BUTTON_ACTION_STYLE = 'mt-6 w-full'

export const Button = ({
  color: btnColor = 'primary',
  children,
  type = 'button',
  className,
  ...props
}: ButtonProps) => {
  const colorClass = buttonClasses[btnColor]
  return (
    <button
      {...props}
      type={type}
      className={classNames(
        `flex justify-center text-sm leading-5 px-4 py-3 rounded border-0`,
        className,
        colorClass,
        {
          'opacity-60': props.disabled,
        }
      )}
    >
      {children}
    </button>
  )
}

export type ButtonDecoratorProps = {
  decorator?: React.ReactNode
  label?: React.ReactNode
}

export const ButtonDecorator = (props: ButtonDecoratorProps) => {
  return (
    <div className="flex gap-2 items-center justify-center">
      <span className="order-2 hidden md:block h-5  text-sm leading-5">{props.label}</span>
      <span className="relative only:-mx-4 ">
        <div className="w-5 h-5 flex justify-center items-center">{props.decorator}</div>
      </span>
    </div>
  )
}

/** Contains generic button types needed in many places eg "search" */

export const Btn = {
  search: (props: ButtonProps) => (
    <Button
      className={classNames('flex items-center ml-10  px-4 py-3 rounded', props.className)}
      {...props}
    >
      <ButtonDecorator
        decorator={<img src={ic_search_white} alt="search" className="mr-2  max-w-none" />}
        label={'Search'}
      />
    </Button>
  ),
  clear: (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
    const { className, ...rest } = props
    return (
      <button
        className={classNames(
          'font-semibold ml-5 px-4 py-3 rounded',
          { 'text-disabledFontColor ': props.disabled },
          className
        )}
        {...rest}
      >
        Clear
      </button>
    )
  },
  add: (props: ButtonProps) => (
    <Button className={classNames('flex items-center', props.className)} {...props}>
      <ButtonDecorator
        decorator={<img src={ic_add_btn_small} alt="search" />}
        label={props.children}
      />
    </Button>
  ),
  delete: (props: ButtonProps) => (
    <Button className={classNames('flex items-center', props.className)} {...props}>
      <ButtonDecorator decorator={<DeleteSvg />} label={props.children} />
    </Button>
  ),
  edit: (props: ButtonProps) => (
    <Button className={classNames('flex items-center', props.className)} {...props}>
      <ButtonDecorator decorator={<img src={edit} alt="edit" />} label={props.children} />
    </Button>
  ),
  settings: (props: ButtonProps) => (
    <Button className={classNames('flex items-center', props.className)} {...props}>
      <ButtonDecorator decorator={<img src={settings} alt="settings" />} label={props.children} />
    </Button>
  ),
}
